import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { loadPublicResourcesForHub } from "@/lib/query-registry";
import { ResourceHub, collectionPageJsonLd } from "@/components/site/ResourceHub";
import { SITE_URL } from "@/lib/i18n";
import coverConvEs from "@/assets/cover-pillar-conversion-es.jpg";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/recursos/conversion";
const ALT = "/resources/conversion";
const TITLE = "Recursos de CRO Shopify: PDP, checkout, UX · Shugert";
const DESC =
  "Índice de nuestros playbooks de CRO en Shopify, claridad de PDP, UX móvil, fricción en checkout, talla y A/B testing. Empieza por el Playbook de CRO para Shopify.";

export const Route = createFileRoute("/es/recursos/conversion")({
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    return loadPublicResourcesForHub(context.queryClient);
  },
  head: ({ loaderData }) => {
    const resources = (loaderData as any)?.resources ?? [];
    const urls = resources
      .filter((r: any) =>
        ((r.tags_es?.length ? r.tags_es : r.tags_en) ?? []).join(" ").toLowerCase()
          .match(/cro|conversion|conversión|checkout|pdp|ux|size guide|talla/),
      )
      .map((r: any) => `${SITE_URL}/es/recursos/${r.slug_es ?? r.slug}`);
    return buildHead({
      locale: "es",
      title: TITLE,
      description: DESC,
      path: PATH,
      altPath: ALT,
      ogImage: coverConvEs,
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Inicio", path: "/es" },
          { name: "Recursos", path: "/es/recursos" },
          { name: "Conversión", path: PATH },
        ]),
        collectionPageJsonLd("Recursos de CRO Shopify", `${SITE_URL}${PATH}`, DESC, urls),
      ],
    });
  },
  component: () => (
    <SiteShell>
      <ResourceHub
        locale="es"
        cluster="conversion"
        copy={{
          eyebrow: "Recursos de CRO",
          title: "Recursos de CRO Shopify: PDP, checkout, UX y testing.",
          intro:
            "Índice de nuestro trabajo de conversión en Shopify. Empieza aquí → el Playbook de CRO para Shopify es el pillar; los artículos de abajo cubren claridad de PDP, UX móvil, fricción en checkout, returns por talla y A/B testing.",
          serviceLabel: "Ver CRO + SEO",
          serviceHref: "/es/cro-shopify",
          articlesTitle: "Guías de conversión",
          articlesEmpty: "Más guías de conversión pronto. ¿Quieres una auditoría de CRO? Solicita un scope.",
          read: "Leer",
          min: "min",
          by: "Por",
          updated: "Actualizado",
          backLabel: "Recursos",
          backHref: "/es/recursos",
        }}
      />
    </SiteShell>
  ),
});